const REIWA = 2019;
const HEISEI = 1989;
const SHOWA = 1926;
const TAISHO = 1912;
const MEIJI = 1868;

export const toWareki = (year: number) => {
  if (year > REIWA) {
    return `令和${year - REIWA + 1}年`;
  } else if (year === REIWA) {
    return "平成31年/令和元年";
  } else if (year > HEISEI) {
    return `平成${year - HEISEI + 1}年`;
  } else if (year === HEISEI) {
    return "昭和64年/平成元年";
  } else if (year > SHOWA) {
    return `昭和${year - SHOWA + 1}年`;
  } else if (year === SHOWA) {
    return "大正15年/昭和元年";
  } else if (year > TAISHO) {
    return `大正${year - TAISHO + 1}年`;
  } else if (year === TAISHO) {
    return "明治45年/大正元年";
  } else if (year > MEIJI) {
    return `明治${year - MEIJI + 1}年`;
  } else if (year === MEIJI) {
    return "慶応4年/明治元年";
  } else {
    return `${year}年`;
  }
};
